//监听浏览器tab标签
listenIn_tab()
function listenIn_tab(){
  // 创建监听浏览器切换窗口
  document.addEventListener('visibilitychange', () => {
  if(document.visibilityState === 'hidden') { // 离开当前tab标签
    }else {
      user_if_login()
      // get_cookie()
    }
  })
}

//判断登录态
function user_if_login(){
  let customerId = window.CustomerID; //用户id
  console.log(customerId);
  if(!customerId){
    get_cookie()
  }
}

// 浏览器获取toekn检查
function get_cookie(){
  let decodedCookies = {};
  let cookieValue = document.cookie;
  if(cookieValue && cookieValue.length != 0){
    cookieValue.split(';').forEach(cookie => {
      let parts = cookie.split('=');
      let key = decodeURIComponent(parts[0].trim()); //decodeURIComponent反转译
      let value = decodeURIComponent(parts[1]);
      decodedCookies[key] = value;
    });
    // console.log(decodedCookies.DIV_authentication)
    let token = decodedCookies.DIV_authentication
    // console.log(decodedCookies.customer_auth_session_created_at)

    const DIV_authentication_expire = decodedCookies.DIV_authentication_expire; // 过期时间
    let refresh = true
    if(DIV_authentication_expire){
      const new_expire = DIV_authentication_expire - 0; // 减去1小时（3600秒）
      const currentTime = Math.floor(Date.now() / 1000); // 获取当前时间戳（秒）
      if (currentTime > new_expire) {
        refresh = false
        console.log("中心过期");
      } else {
        refresh = true
        console.log("中心期间");
      }
    }

    if(token && token != 'undefined' && token != '' && refresh){
      //商城未登录
      //if(!decodedCookies.customer_auth_session_created_at){
        get_token(token)
      //}
    }
  }
}

//获取登录信息
function get_token(token){
  // 使用fetch API发送HTTP GET请求访问API接口
  let url = ``;
  let env = `production`;
  if(env == 'production'){
    url = `https://api-user.tozostore.com/api/center/getshopifylink`;
  }else{
    url = `https://api-user.tozostore.com/api/center/getshopifylink`;
    //url = `https://api-user.tozo.tech/api/center/getshopifylink`;
  }
  let redirect_url =  location.href
  fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    body: JSON.stringify({
      redirect_url: redirect_url,
    })
  })
  .then(response => response.json())
  .then(res => {
    console.log(res)
    if(res.code == 0){
      location.href = res.data.redirect_url
    }
  })
  .catch(error => console.error(error));
}

//判断登录态
user_if_login()